

import React, { Component } from 'react';
import classNames from 'classnames';
import get from 'lodash/get';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

const clsPrefix = 'app-map-image-container';

const MAPBOX_TOKEN =
  'pk.eyJ1IjoiZ2xpZGVsYWJzIiwiYSI6ImNqbzYxZXF1MTBncDIza3FtaTN1b3psbjUifQ.ub54b194M0NCiqDQokbLCA';

@inject('ui')
@observer
export default class MapImageContainer extends Component {
  static propTypes = {
    className: PropTypes.string,
    address: PropTypes.object,
  };

  render() {
    const { className, address } = this.props;
    const latitude = get(address, 'components.latitude');
    const longitude = get(address, 'components.longitude');
    return latitude ? (
      <img
        className={classNames(className, clsPrefix)}
        src={`https://api.mapbox.com/styles/v1/glidelabs/cjo6eusjg19rc2smqvhcgsvzw/static/${longitude},${latitude},14.1,0,0/1280x300@2x?access_token=${MAPBOX_TOKEN}`}
        alt=""
      />
    ) : (
      <div
        className={classNames(className, clsPrefix, `${clsPrefix}--empty`)}
        alt=""
      />
    );
  }
}
